import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_VACATION';

export async function createVacation(
    userToken: string,
    newVacation: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/productions/vacations/`,
            data: newVacation,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de la création d\'un congé',
            error: error
        });
    }
}
